export enum OfferType {
  cash = "CASH",
  repair = "REPAIR",
  denied = "DENIED",
}
